/**
 * GMM order bump — adds the checked add-on alongside the main product.
 *
 * The submit is intercepted at document level in the CAPTURE phase so it
 * always runs before Dawn's own ProductForm submit listener (which is bound
 * in the custom element constructor, before this script executes).
 *
 * The main product is posted as the original multipart FormData so file
 * properties (intake photo) survive; the add-on follows as a second JSON
 * add. The cart is re-rendered from the final response.
 */
(function () {
  var ABORT = {};

  function bumpCheckbox(form) {
    return form && form.querySelector('.gmm-order-bump__check:checked');
  }

  function postAdd(body, headers) {
    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: Object.assign(
        { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        headers || {}
      ),
      body: body,
    }).then(function (r) {
      return r.json();
    });
  }

  function getCart(pf) {
    return (
      (pf && pf.cart) ||
      document.querySelector('cart-notification') ||
      document.querySelector('cart-drawer')
    );
  }

  function runBumpFlow(pf, form, bump) {
    var submitButton = pf.submitButton || pf.querySelector('[type="submit"]');
    if (submitButton && submitButton.getAttribute('aria-disabled') === 'true') return;

    var spinner = pf.querySelector('.loading__spinner');
    if (typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage();
    if (submitButton) {
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
    }
    if (spinner) spinner.classList.remove('hidden');

    var cart = getCart(pf);
    var sections =
      cart && typeof cart.getSectionsToRender === 'function'
        ? cart.getSectionsToRender().map(function (s) {
            return s.id;
          })
        : null;
    if (cart && typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }

    var hadError = false;
    var mainId = null;
    var mainKey = null;

    // 1. Main product, exactly as the browser would submit it (photo preserved).
    var mainData = new FormData(form);
    mainId = mainData.get('id');
    if (sections) {
      mainData.append('sections', sections.join(','));
      mainData.append('sections_url', window.location.pathname);
    }

    postAdd(mainData)
      .then(function (response) {
        if (response.status) {
          hadError = true;
          if (typeof pf.handleErrorMessage === 'function') {
            pf.handleErrorMessage(response.description);
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: mainId,
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          throw ABORT;
        }
        mainKey = response.key || (response.items && response.items[0] && response.items[0].key);

        // 2. The add-on.
        var payload = {
          items: [{ id: bump.dataset.variantId, quantity: 1, properties: { _order_bump: 'yes' } }],
        };
        if (sections) {
          payload.sections = sections;
          payload.sections_url = window.location.pathname;
        }
        return postAdd(JSON.stringify(payload), { 'Content-Type': 'application/json' })
          .then(function (second) {
            // If the add-on fails, still surface the successful main add.
            return second && !second.status ? second : response;
          })
          .catch(function () {
            return response;
          });
      })
      .then(function (finalResponse) {
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: mainId,
            cartData: finalResponse,
          });
        }
        // cart-notification needs the main line-item key; multi-step adds
        // leave it pointing at the bump line otherwise.
        if (mainKey) finalResponse.key = mainKey;
        cart.renderContents(finalResponse);
      })
      .catch(function (e) {
        if (e !== ABORT) console.error(e);
      })
      .finally(function () {
        if (submitButton) {
          submitButton.classList.remove('loading');
          if (!hadError) submitButton.removeAttribute('aria-disabled');
        }
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!form || !form.closest) return;
      var pf = form.closest('product-form');
      if (!pf) return;
      var bump = bumpCheckbox(form);
      if (!bump) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      runBumpFlow(pf, form, bump);
    },
    true
  );

  // Apple Pay / Shop Pay / Buy it now build a single-item EXPRESS checkout
  // that bypasses the cart entirely, so a checked add-on can never ride
  // along. When the bump is checked, hide the express buttons and say why;
  // the main button carries both items through /cart/add.
  function syncExpressCheckout(check) {
    var pf = check.closest('product-form');
    if (!pf) return;
    var buttons = pf.querySelector('.product-form__buttons');
    if (!buttons) return;
    var pay = buttons.querySelector('.shopify-payment-button');
    if (!pay) return;
    var on = check.checked;
    pay.style.display = on ? 'none' : '';
    var note = buttons.querySelector('[data-gmm-bump-note]');
    if (on && !note) {
      note = document.createElement('p');
      note.className = 'gmm-bump-note';
      note.setAttribute('data-gmm-bump-note', '');
      note.textContent = 'Add-on included. Checkout with the button above to keep both in your order.';
      buttons.appendChild(note);
    }
    if (note) note.hidden = !on;
  }

  document.addEventListener('change', function (e) {
    var check = e.target && e.target.closest ? e.target.closest('.gmm-order-bump__check') : null;
    if (check) syncExpressCheckout(check);
  });

  function initExpressSync() {
    document.querySelectorAll('.gmm-order-bump__check').forEach(syncExpressCheckout);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExpressSync);
  } else {
    initExpressSync();
  }
  // bfcache: re-sync when coming back with the box still checked
  window.addEventListener('pageshow', initExpressSync);

  // One-click add from the cart drawer / cart page bump.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-bump-add]');
    if (!btn) return;
    var wrap = btn.closest('[data-cart-bump]');
    var variantId = wrap && wrap.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    var onCartPage = document.body.classList.contains('template-cart');
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var payload = {
      items: [{ id: variantId, quantity: 1, properties: { _order_bump: 'yes' } }],
    };
    if (!onCartPage && cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (s) {
        return s.id;
      });
      payload.sections_url = window.location.pathname;
    }

    postAdd(JSON.stringify(payload), { 'Content-Type': 'application/json' })
      .then(function (response) {
        if (response.status) {
          btn.disabled = false;
          btn.textContent = 'Add';
          return;
        }
        if (onCartPage) {
          window.location.reload();
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-bump', cartData: response });
        }
        if (cart) {
          if (!response.key && response.items && response.items[0]) {
            response.key = response.items[0].key;
          }
          cart.renderContents(response);
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add';
      });
  });
})();
